import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

const baseStyles = ({ theme, top }) => css`
  position: fixed;
  top: ${top};
  left: 0;
  width: 100%;
  z-index: ${theme.zIndex.drawer};
`;

const FixedContainer = styled('div')(baseStyles);

FixedContainer.propTypes = {
  top: PropTypes.string,
};

FixedContainer.defaultProps = {
  top: '52px',
};

export default FixedContainer;
